import type { ExtensionManifest } from '@atlaskit/editor-common/extensions';
import React from 'react';

export const redactionExtension = () => {
	return {
		title: 'Redaction',
		type: 'com.atlassian.guard-premium',
		key: 'redaction',
		description: 'Inserts redacted block.',
		icons: {
			// eslint-disable-next-line import/dynamic-import-chunkname
			'48': () => import('@atlaskit/icon/glyph/editor/addon'),
		},
		modules: {
			nodes: {
				default: {
					type: 'inlineExtension',
					render: async () => () => <span>[REDACTED]</span>,
				},
			},
		},
	} as ExtensionManifest;
};
